import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchFlight', request, cancelToken)
}

export {get}
